import ReactDOM from 'react-dom/client';
import '@shopify/polaris/build/esm/styles.css';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import { store } from './redux/store'
import App from './pages/index'
// import NpsModal from "./components/NpsModal";
// import reportWebVitals from './reportWebVitals'
import ChatPlatformIntercom from './components/ChatPlatformIntercom'
import utils from '../src/utils/utils';
import { CWComponentsProvider } from './pages/Admin/Middle/CWComponentsProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
utils.setupResizeObserver();
root.render(
  <Provider store={store}>
      <BrowserRouter>
        {/* 客服 - willdesk */}
        {/* <ChatPlatformWilldesk App="SEOWILL" /> */}
        {/* 客服 - intercom */}
        <ChatPlatformIntercom />
        
        {/* NPS弹窗 */}
        {/* <NpsModal /> */}
        
        <App />

        {/* 中台授权 */}
        <CWComponentsProvider />
      </BrowserRouter>
  </Provider>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// reportWebVitals(console.log)